import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { SpinnerLoader } from 'shared/ui'
import { ChatbotPath } from 'pages/chatbot/route/chatbotPath'

export const ChatbotListPage = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    navigate(`${ChatbotPath.texting}${location.search}`, { replace: true })
  }, [navigate, location.search])

  return <SpinnerLoader ariaLabel={'ChatbotList'} />
}
